import { useEffect, useState } from 'react'

export const useDocument = (): Document => {
  const [d, setD] = useState<Document>()

  useEffect(() => {
    setD(document)
  }, [])

  return d
}
